/**
 * The Jobs and Nav sections' refresh (spec §5.10): while mounted, re-render at `refreshHz` (dashboard.json, 4 Hz)
 * **only while the dashboard is open**; the shell keeps sections mounted but hidden when closed, so a closed
 * dashboard reads nothing.
 */
import { useEffect, useReducer } from 'react'
import { loadDashboardConfig } from '../../config'
import { dashboardOpen } from '../../registry'

export function useOpenRefresh(): void {
  const [, bump] = useReducer((n: number) => n + 1, 0)
  useEffect(() => {
    const iv = window.setInterval(() => {
      if (dashboardOpen()) bump()
    }, 1000 / loadDashboardConfig().refreshHz)
    return (): void => window.clearInterval(iv)
  }, [])
}
